import { Link } from "react-router-dom";
import ComplianceBadge from "./ComplianceBadge";
import { COMPLIANCE_DATA } from "../constants/compliance";
import { Mail, Phone, MapPin } from "lucide-react";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#080808] border-t border-gray-800 mt-auto" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <h3 className="text-xl font-bold text-gray-100 mb-4" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
              Kredere Family Office Private Limited
            </h3>
            <ComplianceBadge />
            <div className="mt-6 space-y-2 text-sm text-gray-400">
              <div className="flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <span>{COMPLIANCE_DATA.address}</span>
              </div>
              <div className="flex items-center gap-2">
                <Phone className="w-4 h-4 flex-shrink-0" />
                <span>{COMPLIANCE_DATA.contactPhone}</span>
              </div>
              <div className="flex items-center gap-2">
                <Mail className="w-4 h-4 flex-shrink-0" />
                <span>{COMPLIANCE_DATA.contactEmail}</span>
              </div>
            </div>
          </div>

          <div>
            <h4 className="font-semibold text-gray-200 mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><Link to="/about" className="hover:text-[#d4af69] transition-colors">About Us</Link></li>
              <li><Link to="/services" className="hover:text-[#d4af69] transition-colors">Services</Link></li>
              <li><Link to="/sif" className="hover:text-[#d4af69] transition-colors">SIF</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-gray-200 mb-4">Legal</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><Link to="/disclaimers" className="hover:text-[#d4af69] transition-colors">Disclaimers</Link></li>
              <li><Link to="/privacy" className="hover:text-[#d4af69] transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-[#d4af69] transition-colors">Terms of Use</Link></li>
              <li><Link to="/cookie-policy" className="hover:text-[#d4af69] transition-colors">Cookie Policy</Link></li>
              <li><Link to="/commission-disclosure" className="hover:text-[#d4af69] transition-colors text-xs opacity-70">Commission Disclosure</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-800 text-center text-sm text-gray-500">
          <p>© {currentYear} {COMPLIANCE_DATA.legalName}. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}